import { CssFeatureSymbol } from '../../ioc/catharsis-ioc'
import { canvas } from './canvasCompNode'
import { canvasDomApplier } from './canvasDomApplier'
import { compInfoNodes } from '@wix/thunderbolt-component-isolation'
import type { CanvasCssFeature } from './canvas.types'
import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'

export const canvasCssFeature: CanvasCssFeature = {
	featureName: 'canvas',
	experimentName: 'OPEN_TO_ALL',
	renderableNodes: { canvas },
	intermediateNodes: { hasResponsiveLayout: compInfoNodes.hasResponsiveLayout },
	dataMaps: ['effects'],
	domApplier: canvasDomApplier,
}

export const page: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(canvasCssFeature)
}
export const editor: BindFeature = page
